export const getEnableAuth0LoginForUser = (state) =>
    state.lookup?.enableAuth0LoginForUser;

export const getLookupLoading = (state) => state.lookup?.lookupLoading;

export const getAuth0RedirectUrl = (state) => state.lookup?.auth0RedirectUrl;
